module.exports = ".test-scroll {\n  overflow-y: scroll !important;\n  height: 600px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/buyer/chat-test/chat-test.component.scss
// module id = ./src/app/buyer/chat-test/chat-test.component.scss
// module chunks = main